import { type CatalogPermissionSecondaryCategoryConfigConstructor } from '@webapp/modules/purchasing/entities/CatalogPermissionSecondaryCategoryConfig'
import { type CatalogPermissionDeptConfigApiModel } from '../api-models/CatalogPermissionDeptConfigApiModel'

export const mapCatalogPermissionDeptConfigApiModel = (
  apiModel: CatalogPermissionDeptConfigApiModel
): CatalogPermissionSecondaryCategoryConfigConstructor => {
  return {
    id: apiModel.id,
    name: apiModel.name,
    primaryCategoryName: apiModel.branch.name,
    grantedUserIds: apiModel.list.map((u) => u.id),
  }
}
